/* eslint-disable camelcase */
/* eslint-disable new-cap */

import { flightRulesEnum, fplOriginatorPhone, payloadCodeTypeEnum } from "../../dataStruct";
import { parseCss } from "../../functions";
import { fccProvider } from "./fccProvider";
import { queryPublishedRoster } from "./fccProvider";
import { flightPlanCallsign } from "./flight-plan-callsign";
import { environment } from "../../../../../environments/environment";

export class opsTemplateStruct {
  fplTemplates: fplTemplStruct[];
}

export class fplTemplStruct {
  flightNumber: string;
  registration: string;
  templateName: string;
  originMethod: originMethodEnum;
  destinationMethod: destinationMethodEnum;
  alternateMethod: alternatenMethodEnum;
  flightRules: flightRulesEnum;
  TypeOfFlight: typeOfFlightStruct;
  DateOfDeparture: dateOfDepStruct;
  TimeOfDeparture: timeOfDepStruct;
  VertlevelRef: vertLevelRefStruct;
  Route: string;
  FuelMethod: fuelMethodStruct;
  personsAboardMethod: personsAboardMethodEnum;
  Remarks: string;
  PilotIncommand: string;
  homeBaseGeoPos: any;
  homeBaseIdent: string;
  destinationGeoPos: number[];
  opsRemarks: string;
  opsRemarksHtml: string;
  opsAnyid: number; // also used for mission ID @ cfv
}

export enum originMethodEnum {
  home = 1,
  lastDest = 2,
  ppos = 3,
}

export enum destinationMethodEnum {
  home = 1,
  nearest = 2,
  origin = 3,
  coordinates = 4,
}
export enum alternatenMethodEnum {
  origin = 1,
  nearest = 2,
}

export enum fuelMethodStruct {
  mtow = 1,
  minReq = 2,
  specific = 3,
  dutyOfp = 4,
}
export enum personsAboardMethodEnum {
  fccBookings = 1,
  fccBookingsPlus1 = 2,
}

export enum vertLevelRefStruct {
  alt = 1,
  fl = 2,
  vfr = 3,
}

export enum dateOfDepStruct {
  today = 1,
  tomorrow = 2,
}

export enum timeOfDepStruct {
  now = 1,
  fiveMin = 2,
  fivteenMin = 3,
  thirtyMin = 4,
}

export enum typeOfFlightStruct {
  G = 1,
  S = 2,
  N = 3,
  X = 4,
}

export enum transpStruct {
  S = 1,
  C = 2,
}

export class opsTemplateProvider {
  // this is to avoid waiting for the crew update to
  // finish (will use the last duty there was)
  private currDuty_latch: any = undefined;
  private init: boolean = false;

  private lastValidFplTemplates: fplTemplStruct[] = [];
  async getFplTemplates(dutyId: string, classCom: any): Promise<fplTemplStruct[]> {
    const tmp: fplTemplStruct[] = [];

    try {
      let result_fcc = [
        ...(await queryPublishedRoster(classCom, "dutyByDutyIdCis", { dutyId })),
        ...(await classCom.namedQuery("dutyByDutyId", { dutyId })),
      ];

      if (result_fcc.length == 0 || this.init) {
        if (this.currDuty_latch !== undefined) {
          result_fcc = this.currDuty_latch;
        }
      } else {
        this.currDuty_latch = result_fcc;
      }

      // if still nothing usable, return last valid templates
      if (!result_fcc || result_fcc.length === 0) {
        return this.lastValidFplTemplates.map((t) => ({ ...t }));
      }

      const currDuty = result_fcc[0];
      if (!currDuty) {
        return this.lastValidFplTemplates.map((t) => ({ ...t }));
      }

      let home_pos: string = "";
      let homeBaseIdent: string = "";
      try {
        home_pos = JSON.parse(parseCss(currDuty.parameters, "homebase"));
        homeBaseIdent = result_fcc[0].homeBaseIdent;
      } catch (err) {
        console.warn("warn: could not fetch homebase");
      }

      const flightNumber = flightPlanCallsign(homeBaseIdent, currDuty.aircraftRegistration);

      const result_ac = await classCom.namedQuery("fppAcftParametersByRegistration", {
        registration: currDuty.aircraftRegistration,
      });
      const currAc = result_ac[0];
      const FPL_field18: string = parseCss(currAc?.parameters, "field18");

      const FCC = new fccProvider();
      const currFlightCrew = await FCC.getEntireLoading(dutyId, false, classCom, payloadCodeTypeEnum.pic);

      let phone: string = "";
      try {
        phone = parseCss(currFlightCrew?.[0]?.parameters, "phone");
      } catch (err) {
        console.warn("warn: could not fetch crew phone");
      }

      let nt: fplTemplStruct = new fplTemplStruct();

      nt.flightNumber = flightNumber;
      nt.flightRules = flightRulesEnum.V;
      nt.homeBaseGeoPos = home_pos;
      nt.homeBaseIdent = homeBaseIdent;
      nt.templateName = "DCT near HOSPITAL / AD";
      nt.registration = currDuty.aircraftRegistration;
      nt.originMethod = originMethodEnum.ppos;
      nt.destinationMethod = destinationMethodEnum.nearest;
      nt.alternateMethod = alternatenMethodEnum.nearest;
      nt.DateOfDeparture = dateOfDepStruct.today;
      nt.TimeOfDeparture = timeOfDepStruct.now;
      nt.TypeOfFlight = typeOfFlightStruct.G;
      nt.VertlevelRef = vertLevelRefStruct.vfr;
      nt.Route = "";
      nt.PilotIncommand = currDuty.pilotsAboard;
      nt.FuelMethod = fuelMethodStruct.specific;
      nt.Remarks = FPL_field18 + " " + "RMK/CREW CONTACT " + phone + " FILED BY " + fplOriginatorPhone;
      nt.personsAboardMethod = personsAboardMethodEnum.fccBookingsPlus1;
      tmp.push(nt);

      nt = new fplTemplStruct();
      nt.flightNumber = flightNumber;
      nt.flightRules = flightRulesEnum.V;
      nt.homeBaseGeoPos = home_pos;
      nt.homeBaseIdent = homeBaseIdent;
      nt.templateName = "dct home " + homeBaseIdent;
      nt.registration = currDuty.aircraftRegistration;
      nt.originMethod = originMethodEnum.ppos;
      nt.destinationMethod = destinationMethodEnum.home;
      nt.alternateMethod = alternatenMethodEnum.nearest;
      nt.DateOfDeparture = dateOfDepStruct.today;
      nt.TimeOfDeparture = timeOfDepStruct.now;
      nt.TypeOfFlight = typeOfFlightStruct.G;
      nt.VertlevelRef = vertLevelRefStruct.vfr;
      nt.FuelMethod = fuelMethodStruct.specific;
      nt.Route = "";
      nt.PilotIncommand = currDuty.pilotsAboard;
      nt.Remarks = FPL_field18 + " " + "RMK/CREW CONTACT " + phone + " FILED BY " + fplOriginatorPhone;
      nt.personsAboardMethod = personsAboardMethodEnum.fccBookings;
      if (homeBaseIdent !== "") {
        tmp.push(nt);
      }

      nt = new fplTemplStruct();
      nt.flightNumber = flightNumber;
      nt.flightRules = flightRulesEnum.V;
      nt.homeBaseGeoPos = home_pos;
      nt.homeBaseIdent = homeBaseIdent;
      nt.templateName = "sec TRANSPORT";
      nt.alternateMethod = alternatenMethodEnum.nearest;
      nt.registration = currDuty.aircraftRegistration;
      nt.DateOfDeparture = dateOfDepStruct.today;
      nt.TimeOfDeparture = timeOfDepStruct.fiveMin;
      nt.TypeOfFlight = typeOfFlightStruct.G;
      nt.FuelMethod = fuelMethodStruct.specific;
      nt.VertlevelRef = vertLevelRefStruct.vfr;
      nt.Route = "";
      nt.PilotIncommand = currDuty.pilotsAboard;
      nt.Remarks = FPL_field18 + " " + "RMK/CREW CONTACT " + phone + " FILED BY " + fplOriginatorPhone;
      tmp.push(nt);

      nt = new fplTemplStruct();
      nt.flightNumber = flightNumber;
      nt.flightRules = flightRulesEnum.V;
      nt.homeBaseGeoPos = home_pos;
      nt.homeBaseIdent = homeBaseIdent;
      nt.templateName = "repos / ferry FLIGHT";
      nt.alternateMethod = alternatenMethodEnum.nearest;
      nt.registration = currDuty.aircraftRegistration;
      nt.DateOfDeparture = dateOfDepStruct.today;
      nt.TimeOfDeparture = timeOfDepStruct.thirtyMin;
      nt.TypeOfFlight = typeOfFlightStruct.G;
      nt.FuelMethod = fuelMethodStruct.specific;
      nt.VertlevelRef = vertLevelRefStruct.vfr;
      nt.Route = "";
      nt.PilotIncommand = currDuty.pilotsAboard;
      nt.personsAboardMethod = personsAboardMethodEnum.fccBookings;
      nt.Remarks = FPL_field18 + " " + "RMK/CREW CONTACT " + phone + " FILED BY " + fplOriginatorPhone;

      if (flightNumber == "") {
        tmp.push(nt);
      }

      // cache only valid non-empty result (midnight bug)
      if (tmp.length > 0) {
        this.lastValidFplTemplates = tmp.map((t) => ({ ...t }));
        return tmp;
      }

      return this.lastValidFplTemplates.map((t) => ({ ...t }));
    } catch (err) {
      console.log("could not get FPL Template, return last valid.  " + err);
      return this.lastValidFplTemplates.map((t) => ({ ...t }));
    }
  }

  async createHemsMission(
    dutyId: string,
    classCom: any,
    missionCoords: number[],
    opsRemarks: string,
    anyOpsId?: number
  ): Promise<fplTemplStruct[]> {
    const tmp: fplTemplStruct[] = [];

    try {
      // homepos
      const result_fcc = [
        ...(await queryPublishedRoster(classCom, "dutyByDutyIdCis", { dutyId })),
        ...(await classCom.namedQuery("dutyByDutyId", { dutyId })),
      ];
      const currDuty = result_fcc[0];
      let home_pos: string = "";
      let homeBaseIdent: string = "";
      try {
        home_pos = JSON.parse(parseCss(currDuty.parameters, "homebase"));
        homeBaseIdent = result_fcc[0].homeBaseIdent;
      } catch (err) {
        console.warn("warn: could not fetch homebase");
      }

      const flightNumber = flightPlanCallsign(homeBaseIdent, currDuty.aircraftRegistration);

      // field18 of FPL
      const result_ac = await classCom.namedQuery("fppAcftParametersByRegistration", {
        registration: currDuty.aircraftRegistration,
      });
      const currAc = result_ac[0];
      const FPL_field18: string = parseCss(currAc.parameters, "field18");

      // pilot phone number
      const FCC = new fccProvider();
      const currFlightCrew = await FCC.getEntireLoading(dutyId, false, classCom, payloadCodeTypeEnum.pic);

      const phone: string = parseCss(currFlightCrew[0].parameters, "phone");

      let nt: fplTemplStruct = new fplTemplStruct();
      nt = new fplTemplStruct();
      nt.flightNumber = flightNumber;
      // append this info too, justin case
      nt.flightRules = flightRulesEnum.V;
      nt.homeBaseGeoPos = home_pos;
      nt.homeBaseIdent = homeBaseIdent;
      nt.templateName = environment.missionTemplateName;
      nt.originMethod = originMethodEnum.ppos;
      nt.destinationMethod = destinationMethodEnum.coordinates;
      nt.destinationGeoPos = missionCoords;
      nt.opsRemarksHtml = opsRemarks;
      nt.opsAnyid = anyOpsId;
      nt.alternateMethod = alternatenMethodEnum.nearest;
      nt.registration = currDuty.aircraftRegistration;
      nt.DateOfDeparture = dateOfDepStruct.today;
      nt.TimeOfDeparture = timeOfDepStruct.fiveMin;
      nt.TypeOfFlight = typeOfFlightStruct.G;
      nt.FuelMethod = fuelMethodStruct.specific;
      nt.personsAboardMethod = personsAboardMethodEnum.fccBookings;
      nt.VertlevelRef = vertLevelRefStruct.vfr;
      nt.Route = "";
      nt.PilotIncommand = currDuty.pilotsAboard;
      nt.Remarks = FPL_field18 + " " + "RMK/CREW CONTACT " + phone + " FILED BY " + fplOriginatorPhone;
      tmp.push(nt);

      return tmp;
    } catch (err) {
      console.log("could not get FPL Template! " + err);
    }
  }
}
